<template>
  <auth>
    <div
      v-if="is_loaded"
      class="auth"
    >
      <div v-html="$error.handle(error)" />
      <form
        v-if="is_valid"
        @submit.prevent="submit"
      >
        <div class="form-group">
          <label>Current Password</label>
          <input
            v-model="password.current_password"
            type="password"
            class="form-control"
          >
        </div>
        <div class="form-group">
          <label>New Password</label>
          <input
            v-model="password.new_password"
            type="password"
            class="form-control"
          >
        </div>
        <div class="form-group">
          <label>Confirm New Password</label>
          <input
            v-model="password.new_password_confirmation"
            type="password"
            class="form-control"
          >
        </div>
        <div class="form-group">
          <button class="btn btn-primary">
            Change Password
          </button>
        </div>
        <br>
      </form>
      <div
        v-else
        class="alert alert-danger"
      >
        <p>Your account could not be found. Plese contact support.</p>
      </div>
    </div>
    <loading v-else />
  </auth>
</template>

<script>
    import Auth from "@/components/Auth.vue";

    export default {
        components: {
            Auth
        },

        data() {
            return {
                password: {
                    password: {
                        current_password: '',
                        new_password: '',
                        new_password_confirmation: ''
                    }
                },
                is_valid: false,
                is_loaded: false,
                error: ''
            }
        },

        mounted() {
            this.fetch()
        },

        methods: {
            fetch() {
                this.is_valid = true;
                this.is_loaded = true;
            },

            submit() {
                this.is_loaded = false;
                this.$axios.post('/api/v1/update-password', this.password).then(() => {
                    this.$store.dispatch('initialize').then(() => {
                        this.is_loaded = true;
                        this.$router.replace({name: 'dashboard'});
                    });
                }).catch(error => {
                    if (error.response) {
                        this.error = error.response;
                    }
                    this.is_loaded = true;
                })
            }
        }
    }
</script>
<style lang="scss">
    .landing__width {
        margin: auto;
        max-width: 70%;
    }
</style>
